import { HttpLink } from "@apollo/client";

import { environment } from "../../environments/environment";
import { createServiceBaseUrl } from "../../utils/createServiceBaseUrl";

export const getHttpLink = (): HttpLink => {
  return new HttpLink({
    uri: `${createServiceBaseUrl()}${environment.basePath}`, // default value
    credentials: "same-origin",
  });
};
